export const getErrorMessage = (error: unknown, fallback: string): string => {
  let message = '';
  if (error instanceof Error && error.message.trim().length > 0) {
    message = error.message;
  } else if (typeof error === 'object' && error !== null && 'message' in error) {
    const candidateMessage = (error as { message?: unknown }).message;
    if (typeof candidateMessage === 'string' && candidateMessage.trim().length > 0) {
      message = candidateMessage;
    }
  }

  if (message.trim().length > 0) {
    const lower = message.toLowerCase();
    if (
      lower.includes('schema cache') ||
      lower.includes('could not query the database for the schema cache') ||
      lower.includes('pgrst000') ||
      lower.includes('pgrst002')
    ) {
      return fallback;
    }
    return message;
  }

  return fallback;
};

export const getErrorStatus = (error: unknown): number | null => {
  if (typeof error !== 'object' || error === null) {
    return null;
  }

  const candidate = error as {
    status?: unknown;
    statusCode?: unknown;
  };

  if (typeof candidate.status === 'number') {
    return candidate.status;
  }

  if (typeof candidate.statusCode === 'number') {
    return candidate.statusCode;
  }

  return null;
};
